import { UserType } from '@/types/user-story-carousel'
import Service, { getCallApiFunction } from '../service'

export type ParamsType = {
  queryTime?: string
  size: number
}
export type ResponseType = {
  vendorBlocks: UserType[]
}
class FetchFollowVendorBlockApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_EXPLORE_VENDER_BLOCK'
    this.config = {
      url: '/v1/livemall/feed/follow/vendor-block',
      method: 'GET',
      params,
    }
  }
}
export function fetchFollowVendorBlock(params: ParamsType): ResponseType {
  return getCallApiFunction(new FetchFollowVendorBlockApi(params))
}
